import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomFieldDto } from '../entities/custom-field-dto';
import { ParentApiService } from './parent-api-service';

@Injectable({ providedIn: 'root' })
export class CustomFieldApiService extends ParentApiService {

  constructor(private http: HttpClient) { super(); }

  public getPackagingSystemFields(): Observable<CustomFieldDto[]> {
    const url = `${environment.webApiAddress}/api/custom-fields/packaging-systems`;
    return this.http.get<CustomFieldDto[]>(url);
  }

  public getPackagingUnitFields(): Observable<CustomFieldDto[]> {
    const url = `${environment.webApiAddress}/api/custom-fields/packaging-units`;
    return this.http.get<CustomFieldDto[]>(url);
  }

  public getPackagingComponentFields(): Observable<CustomFieldDto[]> {
    const url = `${environment.webApiAddress}/api/custom-fields/packaging-components`;
    return this.http.get<CustomFieldDto[]>(url);
  }
}
